import { darken } from "polished"
import type { KeyboardEvent, MouseEvent, ReactNode } from "react"

import { useCurrentTheme } from "@/theme"
import { withSubscribe } from "@/utils/withSubscribe"

interface Props {
  shouldShow?: boolean
  title?: string | ReactNode
  onOverlayClick?: (
    e: MouseEvent<HTMLElement> | KeyboardEvent<HTMLElement>,
  ) => void
  children: ReactNode
}

const ModalComponent = ({
  shouldShow,
  title,
  children,
  onOverlayClick,
}: Props) => {
  const theme = useCurrentTheme()

  if (!shouldShow) {
    return null
  }

  return (
    <dialog
      open={shouldShow}
      className="absolute top-0 left-0 z-50 flex h-full w-full items-center justify-center bg-transparent"
      data-testid="modal-container"
    >
      <div
        className="absolute top-0 right-0 bottom-0 left-0 bg-primary p-0 opacity-75"
        data-testid="modal-overlay"
        onClick={(e) => onOverlayClick?.(e)}
        onKeyDown={(e) => e.key === "Enter" && onOverlayClick?.(e)}
      />
      <div
        className="relative z-1 mx-4 my-0 w-max max-w-[40rem] min-w-64 rounded-lg bg-secondary p-4xl text-primary"
        style={{
          boxShadow: `0 1px 2px rgba(0, 0, 0, 0.05), 0 1rem 3rem -1rem ${darken(0.1, theme.color["Colors/Background/bg-primary"])}`,
        }}
      >
        {title && (
          <div className="border-b border-solid border-(--text-primary) pb-xs">
            <h5 className="display-sm-regular">{title}</h5>
          </div>
        )}
        <div className="mx-0 my-4">{children}</div>
      </div>
    </dialog>
  )
}

export const Modal = withSubscribe(ModalComponent)
